export enum NotificationStatus {
  DRAFT = 1, // Nháp
  SENT = 2, // Đã gửi
  RE_CALL = 3, // Thu hồi
}
